import React from 'react';
import { Container, Box } from '@mui/material';
import {
  Review,
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
  mapReviewToReviewProps,
} from '@marageti/z4-lib';
import { ViewProps } from './types';
import ZSpinner from '../../../components/z-lib/z-spinner';

const DetailView = ({ review, loading, error }: ViewProps) => {
  if (error) {
    return (
      <ErrorBox>
        <ErrorTitle>
          There was an error getting review details
        </ErrorTitle>
        <ErrorMessage>
          {`Code: ${error.code}: ${error.message}`}
        </ErrorMessage>
      </ErrorBox>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{
        pt: {
          desktop: 5,
          mobile: 3,
        },
        pb: {
          desktop: 9.5,
          mobile: 5,
        },
      }}
      >
        {loading && <Box display="flex" justifyContent="center"><ZSpinner /></Box>}
        {review && (
        <Review
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...mapReviewToReviewProps(review)}
        />
        )}
      </Box>
    </Container>
  );
};

export default DetailView;
